import React, { useCallback } from 'react';
import { useReactFlow } from 'reactflow';
import { ZoomIn, ZoomOut, Move } from 'lucide-react';

interface CanvasControlsProps {
  className?: string;
}

export function CanvasControls({ className = '' }: CanvasControlsProps) {
  const { zoomIn: zoomInFlow, zoomOut: zoomOutFlow, setCenter } = useReactFlow();

  const handleZoomIn = useCallback(() => {
    zoomInFlow({ duration: 300 });
  }, [zoomInFlow]);

  const handleZoomOut = useCallback(() => {
    zoomOutFlow({ duration: 300 });
  }, [zoomOutFlow]);

  const handleCenter = useCallback(() => {
    setCenter(0, 0, { duration: 800 });
  }, [setCenter]);

  return (
    <div className={`flex items-center bg-gray-700/50 rounded-lg overflow-hidden ${className}`}>
      <button
        onClick={handleZoomIn}
        className="p-1.5 hover:bg-gray-600/50 text-gray-400 hover:text-gray-300 transition-colors border-r border-gray-600"
        title="Zoom In"
      >
        <ZoomIn className="w-3.5 h-3.5" />
      </button>
      <button
        onClick={handleZoomOut}
        className="p-1.5 hover:bg-gray-600/50 text-gray-400 hover:text-gray-300 transition-colors border-r border-gray-600"
        title="Zoom Out"
      >
        <ZoomOut className="w-3.5 h-3.5" />
      </button>
      <button
        onClick={handleCenter}
        className="p-1.5 hover:bg-gray-600/50 text-gray-400 hover:text-gray-300 transition-colors"
        title="Center View"
      >
        <Move className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
